import React, { useState, useEffect, useCallback } from "react";
import { Table, Space, Popconfirm, Button, message, Select, Input, Form, Modal, Typography, Flex } from "antd";
import {
    EditOutlined,
    DeleteOutlined,
    PlusOutlined, CheckOutlined, CloseOutlined
} from "@ant-design/icons";
import axios from "../../axios-interceptor.js";
import "../../style/organisationConfig.css"
import { useTranslation } from "react-i18next";
import { showLoader } from "../../utils/showloader.js";
import { getOrgStructure, getStructureDefinition, saveStructureDefinition } from "../../services/OrgStructure.js";
import { useSelector } from "react-redux";

const BACKEND_API = process.env.REACT_APP_BACKEND_API;
// const BACKEND_API = "http://104.198.160.88:8092"

const DefineStructure = (props) => {
    const [selectedStructure, setSelectedStructure] = useState(null);
    const [structureData, setStructureData] = useState([])
    const [tempData, setTempData] = useState([])
    const [formData, setFormData] = useState(null)
    const [form] = Form.useForm();
    const { adminEntitlements } = props
    const { t } = useTranslation();
    const { userInfo } = useSelector(state => state.user);
    useEffect(() => {
        form.setFieldsValue({ ...formData });
    }, [form, formData]);

    const fetchStructure = useCallback(async () => {
        showLoader(true)
        let strData = await getStructureDefinition(userInfo);
        if(strData.data?.length){
            setTempData(strData.data)
            setStructureData(strData.data)
        }
        // await axios({
        //     method: "GET",
        //     url: `${BACKEND_API}/orgstructuredef/1`,
        //     headers: {
        //         userId: 1,
        //     },
        // })
        //     .then((response) => {
        //         let data = response.data
        //         setTempData(data);
        //         setStructureData(data)
        //     })
        //     .catch((error) => {
        //     });
        showLoader(false)
    }, [])

    useEffect(() => {
        if(userInfo?.userId)
            fetchStructure();
    }, [fetchStructure, userInfo]);

    const handleDeleteElement = async (structure, rowIndex) => {
        showLoader(true)
        await axios({
            method: "DELETE",
            url: `${BACKEND_API}/orgstructuredef/${structure.orgDefId}`,
            headers: {
                userId: 1,
            },
        })
            .then((response) => {
                message.success(t('Element deleted successfully'))
                fetchStructure()
            })
            .catch((error) => {
            });
        showLoader(false)
    }

    const onAllowEdit = (structure) => {
        let tempList = structureData.map(data => {
            if (structure.orgDefId === data.orgDefId) {
                return { ...data, isEditable: true }
            } else {
                return { ...data }
            }
        })
        // setStructureData(tempList)
        setTempData(tempList)
        setSelectedStructure({ ...structure })
        setFormData({ ...structure })
    }

    const handleEditElement = (structure) => {

        let editableRows = tempData.filter(data => data.isEditable);
        if (editableRows.length > 0) {
            Modal.confirm({
                title: t('Confirm'),
                content: t("You haven't saved the current structure. Are you sure to continue?"),
                okText: t("Yes"),
                onOk: (event) => {
                    onAllowEdit(structure);
                    Modal.destroyAll()
                },
                footer: (_, { OkBtn, CancelBtn }) => (
                    <>
                        <CancelBtn />
                        <OkBtn />
                    </>
                ),
            });
        } else {
            onAllowEdit(structure)
        }
    }

    const onAddNewElement = () => {
        setSelectedStructure({})
        const newData = {
            key: tempData.length + 1,
            assign: "",
            description: "",
            define: "",
            isEditable: true,
        };
        setFormData({ ...newData })

        let modEnteredData = tempData.map((data, index) => {
            return {
                ...data,
                key: index + 1
            }
        })
        modEnteredData.push(newData)
        setTempData([...modEnteredData]);
    }

    const onSaveAndEditCancel = (type = 'cancel') => {
        if (type === 'cancel') {
            setTempData([...structureData])
        }
        setSelectedStructure(null)
        setFormData(null)
    }

    const onCheck = async () => {
        try {
            await form.validateFields();
            onSaveElement()
        } catch (errorInfo) {
        }
    };

    const onSaveElement = async (record) => {
        let postData = { assign: formData.assign, define: formData.define, description: formData.description }
        if (formData.orgDefId) {
            postData.orgDefId = formData.orgDefId
        }
        // return
        showLoader(true)
        let saveResponse = await saveStructureDefinition(postData, formData.orgDefId ? true : false, userInfo)
        if(saveResponse.status === 200){
            message.success(
                            selectedStructure
                                ? t("Element updated successfully")
                                : t("Element created successfully")
                        );
                        fetchStructure();
                        onSaveAndEditCancel('save');
        } else {
            message.error(saveResponse.message)
        }

        // await axios({
        //     method: formData.tenantId ? "PUT" : "POST",
        //     url: `${BACKEND_API}/orgstructuredef`,
        //     data: { ...postData, tenantId: "1" },
        //     headers: {
        //         Accept: "application/json",
        //         userId: 1,
        //     },
        // })
        //     .then((response) => {
        //         message.success(
        //             selectedStructure
        //                 ? t("Element updated successfully")
        //                 : t("Element created successfully")
        //         );
        //         fetchStructure();
        //         onSaveAndEditCancel('save');
        //     })
        //     .catch((error) => {
        //         // TODO: move it to success
        //     });
        showLoader(false)
    }

    const changeHandler = (key, value, record, rowIndex) => {
        let updatedData = tempData.map((data, index) => {
            let dataObj = { ...data }
            if (index === rowIndex) {
                setFormData({ ...data, [key]: value })
                return { ...dataObj, [key]: value }
            }
            return dataObj
        })
        setTempData(updatedData)
    }

    const tableColumns = [
        {
            title: t("Define"),
            dataIndex: "define",
            key: "define",
            width: "20%",
            render: (text, record, rowIndex) => {
                return (
                    record.isEditable ?
                        <Form.Item name="define" rules={[
                            {
                                required: true,
                                whitespace: true,
                                message: t('Label is required')
                            }
                        ]}>
                            <Input value={record.define} type="text" placeholder={t("Define Label")} onChange={(e) => changeHandler("define", e.target.value, record, rowIndex)} />
                        </Form.Item>
                        : text
                )
            }
        },
        {
            title: t("Assign"),
            dataIndex: "assign",
            key: "Assign",
            width: "20%",
            render: (text, record, rowIndex) => {
                return (
                    record.isEditable ?
                        <Form.Item>
                            <Select placeholder={t("Assign")} value={record.assign || t("Assign")} onChange={(value) => changeHandler("assign", value, record, rowIndex)}
                                options={structureData.map(data => {
                                    return { ...data, label: data.define, value: data.orgDefId }
                                })}
                                style={{ width: "100%" }}
                            />
                        </Form.Item>
                        : text
                )
            }
        },
        {
            title: t("Description"),
            dataIndex: "description",
            key: "Description",
            width: "30%",
            render: (text, record, rowIndex) => {
                return (
                    record.isEditable ? <Input value={record.description} type="text" placeholder={t("Enter description")} onChange={(e) => changeHandler("description", e.target.value, record, rowIndex)} />
                        : text
                )
            }
        },
        {
            title: t("Action"),
            dataIndex: "",
            key: "",
            width: "15%",
            render: (text, record, rowIndex) => {
                return (
                    !record?.isEditable ?
                        <Space>
                            <Button
                                size="small"
                                icon={<EditOutlined />}
                                onClick={() => handleEditElement(record, rowIndex)}
                            />
                            <Popconfirm
                                title={t("Delete the element")}
                                description={t("Are you sure to delete this element?")}
                                okText={t("Yes")}
                                cancelText={t("No")}
                                onConfirm={() => handleDeleteElement(record, rowIndex)}
                            >
                                <Button size="small" icon={<DeleteOutlined />} />
                            </Popconfirm>
                        </Space>
                        : <Space>
                            <Button type="primary" size="small" onClick={() => onCheck()} icon={<CheckOutlined />}></Button>
                            <Button size="small" onClick={() => onSaveAndEditCancel('cancel', rowIndex)} icon={<CloseOutlined />}></Button>
                        </Space>
                )
            },
        }

    ];
    // if (adminEntitlements.includes("Organisation_Structure_Update")) {
    //     tableColumns.push({
    //         title: t("Action"),
    //         dataIndex: "",
    //         key: "",
    //         width: "15%",
    //         render: (text, record, rowIndex) => {
    //             return (
    //                 !record.isEditable ?
    //                     <Space>
    //                         <Button
    //                             size="small"
    //                             icon={<EditOutlined />}
    //                             onClick={() => handleEditElement(record, rowIndex)}
    //                         />
    //                         <Popconfirm
    //                             title={t("Delete the element")}
    //                             description={t("Are you sure to delete this element?")}
    //                             okText={t("Yes")}
    //                             cancelText={t("No")}
    //                             onConfirm={() => handleDeleteElement(record, rowIndex)}
    //                         >
    //                             <Button size="small" icon={<DeleteOutlined />} />
    //                         </Popconfirm>
    //                     </Space>
    //                     : <Space>
    //                         <Button type="primary" size="small" onClick={() => onCheck()} icon={<CheckOutlined />}></Button>
    //                         <Button size="small" onClick={() => onSaveAndEditCancel('cancel', rowIndex)} icon={<CloseOutlined />}></Button>
    //                     </Space>
    //             )
    //         },
    //     })
    // }

    return (
        <div style={{ background: "#fff", padding: "1.5rem", borderRadius: "1rem", marginTop: "1.5rem" }}>
            <Flex justify="space-between" align="center" style={{margin: "0 0 1.5rem 0"}}>

            <Typography.Title level={4} style={{ padding: 0, margin: 0 }} >
                {t("Define Structure")}
            </Typography.Title>
            <Button size="large" className="submit-button" icon={<PlusOutlined />} onClick={onAddNewElement}>{t('New')}</Button>
            
            </Flex>
            <div
                style={{
                    // display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    alignItems: "normal",
                }}
            >
                <div className="organisation-structure table-content">
                    <Form form={form}>
                        <Table className="white-header-table"
                            style={{ width: "100%" }}
                            dataSource={tempData}
                            columns={tableColumns}
                            pagination={false}
                            size="small" // Set the size to 'small' to reduce the height of rows
                        />
                    </Form>
                    {/* {
                        !selectedStructure && adminEntitlements.includes("Organisation_Structure_Update") &&
                        <div style={{ paddingLeft: "14px", marginTop: "10px" }}>
                            <span style={{ fontSize: "14px", color: "#1677ff", cursor: "pointer", padding: "8px" }} onClick={onAddNewElement}><PlusOutlined style={{ marginRight: "5px" }} /> {t("Add")}</span>
                        </div>
                    } */}
                </div>
            </div>
        </div>
    )
}

export default DefineStructure